import { createAsyncActions } from "../../leiten/helpers/createAsyncAction";
import { initialContentLoading } from "../ContentLoading";
export const createRequest = (payloadCreator, set, get, extra) => {
    const initialState = initialContentLoading(extra?.initialContent || null, extra?.initialStatus);
    const reactions = {
        action: (params, status, requestId) => {
            const state = get();
            set({
                ...state,
                content: extra?.contentReducers?.pending
                    ? extra.contentReducers.pending(params)
                    : state.content,
                status: status ?? "loading",
                payload: params,
                requestId: requestId,
            });
            extra?.actionReaction?.(params, status, state.requestId);
        },
        fulfilled: (content, params, requestId) => {
            const state = get();
            if (requestId === state.requestId) {
                set({
                    ...state,
                    content: extra?.contentReducers?.fulfilled
                        ? extra.contentReducers.fulfilled(content, params)
                        : content,
                    status: "loaded",
                });
                extra?.fulfilledReaction?.(content, params, requestId);
            }
        },
        rejected: (params, error, fetchError, requestId) => {
            const state = get();
            set({
                ...state,
                content: extra?.contentReducers?.rejected
                    ? extra.contentReducers?.rejected(params, error, fetchError)
                    : state.content,
                status: "error",
                error,
                fetchError,
            });
            extra?.rejectedReaction?.(params, error, fetchError, requestId);
        },
        abort: (params, requestId) => {
            const state = get();
            set({
                ...state,
                content: extra?.contentReducers?.aborted ? extra.contentReducers.aborted(params) : null,
                status: extra?.initialStatus || "loading",
                error: null,
                fetchError: undefined,
            });
            extra?.abortReaction?.(params, requestId);
        },
        resolved: (params, requestId) => {
            extra?.resolvedReaction?.(params, requestId);
        },
    };
    const { action, abort } = createAsyncActions(payloadCreator, reactions);
    const abortAction = () => {
        set(initialState);
        return abort();
    };
    const clear = () => {
        set(initialState);
    };
    const setAtom = (value, rewrite = false) => {
        const state = get();
        const objectContent = rewrite
            ? { ...value }
            : { ...state.content, ...value };
        const content = typeof value === "object" ? objectContent : value;
        set({ ...state, content });
    };
    return { abort: abortAction, action, atom: initialState, clear, setAtom };
};
/** @deprecated use leitenRequest instead */
export const createSlice = (set, get, name, payloadCreator, extra) => {
    return {
        [name]: createRequest(payloadCreator, (atom) => {
            set((state) => {
                return { [name]: { ...state[name], atom } };
            });
        }, () => get()[name].atom, extra),
    };
};
